import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { EventCalendarData } from '../../EventCalendarData'
import { useRef, useEffect, useCallback, useState } from 'react'
import EventCalendarPopup from './EventCalendarPopup'

const localizer = momentLocalizer(moment)

const EventsCalendar = (props) => {
  const [event, setEvent] = useState();
  const [showEventCalendarPopup, setShowEventCalendarPopup] = useState(false);

  const clickRef = useRef(null);

  const onSelectEvent = useCallback((calEvent) => {
    setEvent(calEvent);
    setShowEventCalendarPopup(true);
    console.log("show event popup");
    /**
     * Here we are waiting 250 milliseconds (use what you want) prior to firing
     * our method. Why? Because both 'click' and 'doubleClick'
     * would fire, in the event of a 'doubleClick'. By doing
     * this, the 'click' handler is overridden by the 'doubleClick'
     * action.
     */
    // window.clearTimeout(clickRef?.current)
    // clickRef.current = window.setTimeout(() => {
    //   if (window.confirm(`Get your ticket now! Go to event's page?`)) {
    //     window.open(calEvent.url, '_blank');
    //   }
    // }, 200)
  }, [])

  useEffect(() => {
    console.log(EventCalendarData);

    return () => {
      window.clearTimeout(clickRef?.current)
    }
  }, [])

  return (
    <div className="event-calendar-container">
      <Calendar
        localizer={localizer}
        events={EventCalendarData}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={onSelectEvent}
        style={{ height: 600 }}
      />
      {showEventCalendarPopup && <EventCalendarPopup event={event} setShowEventCalendarPopup={setShowEventCalendarPopup} />}
    </div>
  )
}

export default EventsCalendar;